__turbopack_context__.v({
  "avatar": "onboardingFirstPaywall-module__bQj8Kq__avatar",
  "dot-pulse": "onboardingFirstPaywall-module__bQj8Kq__dot-pulse",
  "enter": "onboardingFirstPaywall-module__bQj8Kq__enter",
  "halo": "onboardingFirstPaywall-module__bQj8Kq__halo",
  "hero": "onboardingFirstPaywall-module__bQj8Kq__hero",
  "pricing": "onboardingFirstPaywall-module__bQj8Kq__pricing",
  "scrim": "onboardingFirstPaywall-module__bQj8Kq__scrim",
  "ticker": "onboardingFirstPaywall-module__bQj8Kq__ticker",
  "ticker-cycle": "onboardingFirstPaywall-module__bQj8Kq__ticker-cycle",
  "tickerDot": "onboardingFirstPaywall-module__bQj8Kq__tickerDot",
  "tickerText": "onboardingFirstPaywall-module__bQj8Kq__tickerText",
});
